import { NgModule } from "@angular/core";
import { FiQuizViewComponent } from "./fi-quiz-view.component";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FiAttachmentsModule } from "@fi-shared/media-bank/fi-attachments/fi-attachments.module";
import { FiAppTextSharedModule } from "@fi-shared/app-text";
import { FiMatIconCheckboxMenuModule } from "@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module";
import { FiBindHtmlCompileModule } from "@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module";

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        FiAttachmentsModule,
        FiAppTextSharedModule,
        FiMatIconCheckboxMenuModule, 
        FiBindHtmlCompileModule,
    ],
    declarations: [
        FiQuizViewComponent,
    ],
    exports: [
        FiQuizViewComponent,
    ],
})
export class FiQuizViewModule {}